import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import useSWR from "swr";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import { SiteFooter } from "@/components/SiteFooter";
import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import VideoDetail from "@/pages/VideoDetail";
import About from "@/pages/About";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import Support from "@/pages/Support";
import PetRescueSaga from "@/pages/PetRescueSaga";
import HarryPotter from "@/pages/HarryPotter";
import { fetchChannel } from "@/lib/api";
import useTipper from "@/hooks/use-tipper";
import "@/App.css";

function Shell() {
  const { data: channel } = useSWR("/channel", fetchChannel);
  const tipper = useTipper();

  useEffect(() => {
    document.body.classList.toggle("no-ads", Boolean(tipper));
    if (tipper && Array.isArray(window.adsbygoogle)) {
      try {
        window.adsbygoogle.pauseAdRequests = 1;
      } catch {
        /* noop */
      }
    }
  }, [tipper]);
  return (
    <>
      <Header channel={channel} />
      <main className="grain">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/video/:id" element={<VideoDetail />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collections/:slug" element={<CollectionDetail />} />
          <Route path="/pet-rescue-saga" element={<PetRescueSaga />} />
          <Route path="/harry-potter-puzzles-spells" element={<HarryPotter />} />
          <Route path="/support" element={<Support />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <SiteFooter channel={channel} />
      <Toaster theme="dark" position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
